import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-foreground text-background" role="contentinfo">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="h-9 w-9 rounded-lg bg-primary flex items-center justify-center">
                <span className="text-primary-foreground font-display font-bold text-lg">DH</span>
              </div>
              <span className="font-display font-bold text-lg">DH Cleaning Services</span>
            </div>
            <p className="text-sm opacity-70 leading-relaxed">
              Professional cleaning services you can trust. Insured, experienced, and committed to excellence.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display font-semibold text-base mb-4">Quick Links</h4>
            <nav aria-label="Footer quick links" className="flex flex-col gap-2">
              {[
                { label: "Home", to: "/" },
                { label: "Services", to: "/services" },
                { label: "About Us", to: "/about" },
                { label: "Contact", to: "/contact" },
                { label: "Book a Clean", to: "/booking" },
                { label: "Get a Quote", to: "/quote" },
              ].map((link) => (
                <Link key={link.to} to={link.to} className="text-sm opacity-70 hover:opacity-100 transition-opacity">
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display font-semibold text-base mb-4">Our Services</h4>
            <nav aria-label="Footer services links" className="flex flex-col gap-2">
              {["Residential Cleaning", "Commercial Cleaning", "End of Lease Cleaning", "Carpet & Window Cleaning"].map(
                (s) => (
                  <Link key={s} to="/services" className="text-sm opacity-70 hover:opacity-100 transition-opacity">
                    {s}
                  </Link>
                )
              )}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-semibold text-base mb-4">Contact Us</h4>
            <address className="flex flex-col gap-3 text-sm not-italic">
              <a href="tel:+61400000000" className="flex items-center gap-2 opacity-70 hover:opacity-100 transition-opacity">
                <Phone className="h-4 w-4 shrink-0" aria-hidden="true" /> 0400 000 000
              </a>
              <a href="mailto:info@dhcleaning.com.au" className="flex items-center gap-2 opacity-70 hover:opacity-100 transition-opacity">
                <Mail className="h-4 w-4 shrink-0" aria-hidden="true" /> info@dhcleaning.com.au
              </a>
              <span className="flex items-center gap-2 opacity-70">
                <MapPin className="h-4 w-4 shrink-0" aria-hidden="true" /> Melbourne, VIC, Australia
              </span>
            </address>
            <div className="flex gap-3 mt-4">
              <a href="#" aria-label="Follow DH Cleaning on Facebook" className="h-9 w-9 rounded-full bg-background/10 hover:bg-primary flex items-center justify-center transition-colors" rel="noopener noreferrer">
                <Facebook className="h-4 w-4" aria-hidden="true" />
              </a>
              <a href="#" aria-label="Follow DH Cleaning on Instagram" className="h-9 w-9 rounded-full bg-background/10 hover:bg-primary flex items-center justify-center transition-colors" rel="noopener noreferrer">
                <Instagram className="h-4 w-4" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background/10 mt-10 pt-6 text-center text-sm opacity-60">
          © {new Date().getFullYear()} DH Cleaning Services Pty Ltd. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
